// CheckoutSwitch — palanca del flip de checkout de la tienda de sueltos.
//
// Elige en runtime entre:
//   • CheckoutV5      → flujo VIEJO (envuelve CheckoutFlow, wizard día-de-ruta). Default.
//   • CheckoutOneShot → LimpackFlex OneShot (envío por dirección, zona, corte 16h).
//
// La decisión la maneja la key `tienda_checkout_oneshot_activo` de app_config (lectura pública vía
// useTiendaConfig, cache 60s). Se prende/apaga SIN redeploy — flip instantáneo, y si algo sale mal en
// prod se vuelve a apagar en el momento. Default OFF = comportamiento actual, así deployar esto no
// cambia nada hasta que se prenda la palanca.
//
// Va montado dentro de <SoloCliente> en /checkout (App.jsx), que ya deja pasar visitantes + cliente/
// admin — sirve para los dos checkouts. El carrito de /checkout es de productos sueltos (los kits/
// suscripción usan su propio wizard), así que CheckoutOneShot es el destino correcto al prender.
import { useTiendaConfig } from '../../lib/useTiendaConfig'
import CheckoutV5 from './Checkout'
import CheckoutOneShot from './CheckoutOneShot'

// Loader neutro para el primer tick (mientras resuelve la palanca). Evita montar un checkout y después
// swappear al otro: montamos UNO solo, una vez resuelta la config. En visitas repetidas (cache) es
// instantáneo.
function CheckoutLoader() {
  return (
    <div style={{
      minHeight: '100vh', background: '#0A1424', color: '#F1F5F9',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
        <div style={{
          width: 34, height: 34, borderRadius: '50%',
          border: '3px solid rgba(0,168,181,0.25)', borderTopColor: '#00A8B5',
          animation: 'chkspin 0.8s linear infinite',
        }} />
        <div style={{ fontSize: 13, color: 'rgba(241,245,249,0.65)', fontWeight: 600 }}>Preparando tu compra…</div>
      </div>
      <style>{'@keyframes chkspin{to{transform:rotate(360deg)}}'}</style>
    </div>
  )
}

export default function CheckoutSwitch() {
  const { config, cargando } = useTiendaConfig()
  if (cargando) return <CheckoutLoader />
  return config.checkoutOneshotActivo ? <CheckoutOneShot /> : <CheckoutV5 />
}
